<template>
    <div class="warp">
        <div class="menu_box">
            <div class="nav_box">
                <el-menu :default-active='activeIndex' mode="horizontal" class="el-menu-demo">
                    <el-menu-item index="1" @click="toVideo">视频</el-menu-item>
                    <el-menu-item index="2" @click="toImage">图片</el-menu-item>
                </el-menu>
            </div>
            <!-- <div class="volume_box" ref="capacity_progress_bar"> -->
            <div class="volume_box">
                <div :style="progressBarWidth"></div>
                <div>{{usesizetext}}/{{totalcapacity}}</div>
            </div>
        </div>
        <div class="image">
            <div class="left_menu_box">
                <!-- <div class="top_box" :class="leftMenuIsSelect == -1 ? 'is_select' : 'no_select'" @click="leftMenuClick(-1)">全部图片</div> -->
                <div class="img_list" v-for="(item, index) of imgCollection" :key="index" :class="leftMenuIsSelect == index ? 'is_select' : 'no_select'" @click="leftMenuClick(index, item.catalogid)">
                    <div>
                        <span class="el-dropdown-link" v-if="index == 0">
                           {{item.catename}}
                            <i style="display: inline-block;width: 24px;"></i>
                        </span>
                        <el-dropdown v-else>
                            <span class="el-dropdown-link">
                               {{item.catename}}
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item @click.native="rename(index, item.catalogid, item.catename)">重命名</el-dropdown-item>
                                <el-dropdown-item @click.native="delImgCollection(index, item.catalogid)">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="add_box" :class="leftMenuIsSelect == -2 ? 'is_select' : 'no_select'" @click="leftMenuClick(-2)">
                    <img :src="addIcon" alt="">
                    <span>增加图片合集</span>
                </div>
            </div>
            <el-dialog title="重命名" :visible.sync="reNameCollTips">
                <el-input v-model="newName" placeholder="请输入名称"></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="reNameCollTips = false">取 消</el-button>
                    <el-button type="primary" @click="sureRename()">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title="增加图片合集" :visible.sync="addImgCollection">
                <el-input v-model="params.name" placeholder="请输入图片合集名称"></el-input>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="addImgCollection = false">取 消</el-button>
                    <el-button type="primary" @click="sureAddClick()">确 定</el-button>
                </div>
            </el-dialog>
            <div class="right_main_box">
                <!-- <div class="top" v-show="leftMenuIsSelect === -1" v-if="permission.btnList.indexOf('A070002')==-1"> -->
                <div class="top" v-show="leftMenuIsSelect === 0">
                    <div class="left_box">
                        <div class="upload_box">
                            <uploadFile v-if="checkDisabled === false" :checkDisabled="checkDisabled" :uploadType="uploadType" @setFile="setFile" :fileRule="fileRule" ref="uploadFile"></uploadFile>
                            <el-button v-else-if="checkDisabled === true" type="primary" disabled>上传图片</el-button>
                        </div>
                        <div class="tips_box">
                            <span style="color: #FA5555"> * </span> 支持的图片格式：jpg、png、gif等，大小不超过20M
                        </div>
                    </div>
                </div>
                <div class="img_content_list">
                    <div class="no_content" v-show="imgListData.length == 0">
                        <span>
                            暂无内容
                        </span>
                    </div>
                    <div class="img_content_box" v-show="imgListData.length !== 0">
                        <div class="select_box">
                            <div>
                                <el-checkbox v-model="isAllChecked" @change="checkAll">全选</el-checkbox>
                                <span>{{selectRecords}}条</span>
                            </div>
                            <div v-show="isAllChecked || selectRecords > 0">
                                <span @click="multipleClassify(imgListData)">分类</span>
                                <span @click="multipleDownload(imgListData)">下载</span>
                                <span v-if="leftMenuIsSelect === 0" @click="multipleDel(imgListData)">删除</span>
                            </div>
                        </div>
                        <div class="imgs_box"  v-viewer="{loading: true,title: true,loop: true,toolbar:true,navbar:false,title:false, transition: false}">
                        <!-- <div class="imgs_box" v-viewer> -->
                            <div class="img_item" v-for="(item,index) of imgListData" :key="index">
                                <div>
                                    <img  v-lazy="item.csfileurl" alt="">
                                    <p @click="selectImg(index)" :class="item.aboolean ? 'show' : 'normal'"></p>
                                </div>
                                <div :title="item.name">
                                    {{item.name}}
                                </div>
                                <div>
                                    <span @click="classifyClick(item.innerid)">分类</span>
                                    <span @click="downloadIamge(item.csfileurl, item.name)">下载</span>
                                    <span @click="editClick(item.innerid, item.name)">编辑</span>
                                    <span v-if="!currentPageGroupId" @click="allDelete(item.innerid)">删除</span>
                                    <span v-else-if="currentPageGroupId" @click="delClick(item.innerid)">移除</span>
                                </div>
                            </div>
                            <el-dialog title="分类" :visible.sync="classifyTips">
                                <div class="classify_box">
                                    <el-checkbox-group v-model="checkList">
                                        <el-checkbox v-for="item in imgCollection" :key="item.catalogid" :label="item.catalogid">{{item.catename}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="classifyTips = false">取 消</el-button>
                                    <el-button type="primary" @click="sureClassify()">确 定</el-button>
                                </div>
                            </el-dialog>
                            <el-dialog title="编辑信息" :visible.sync="editTips">
                                <div class="edit_box">
                                    <el-input v-model="imgNewName" placeholder="请输入名称"></el-input>
                                </div>
                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="editTips = false">取 消</el-button>
                                    <el-button type="primary" @click="sureEdit()">确 定</el-button>
                                </div>
                            </el-dialog>
                        </div>
                        <div class="page">
                            <el-pagination
                                background
                                @current-change="handleSizeChange"
                                :current-page.sync="pageParams.page"
                                :page-size="pageParams.pageSize"
                                :pager-count="11"
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {getAllCapacity, addCollection, getColList, imgColReName, delMaterialGroup, delMaterial, wholedelete, findAllImage, findGroupImage, uploadImage, updateImageofName, imgClassify} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import UploadFile from 'base/upload/uploadFile'
import JSZip from 'jszip'
import FileSaver from 'file-saver'
import {formatFileInfo} from 'common/js/tools'
import _ from 'lodash'
export default {
    name: 'AllOrder',
    data() {
        return {
            checkDisabled: false,
            totalcapacity: '0GB',
            usesizetext: '0MB',
            progressBarWidth: 'width: 1%;',
            activeIndex: '2',
            fileRule: {
                btnName: '上传图片',
                cls: '',
                accept: 'image/png,image/jpeg,image/gif',
                size: 20,
                width: '',
                height: ''
            },
            uploadType: {
                catecode: '93',
                datatype: 'IMAGE'
            },
            total: 0,
            pageParams: {
                page: 1,
                pageSize: 20
            },
            addIcon: require('@/common/images/other/icon_upload@2x.png'),
            testImg: require('@/common/images/other/handheld_idcard.png'),
            testImg1: require('@/common/images/other/Shape@2x.png'),
            testImg2: require('@/common/images/other/Shape2@2x.png'),
            leftMenuIsSelect: 0, // 当前选中左侧菜单
            imgCollection: [], // 左侧图片合集菜单
            addImgCollection: false, // 新增图片合集提示框
            params: {
                name: '', // 图片合集名称
                type: 2
            },
            catalogInnerId: '', // 素材分类的innerid
            newName: '', // 新合集名称
            // oldName: '', // 修改前合集名称
            imgNewName: '', // 单个素材新名称
            imgId: '', // 素材的innerid
            reNameCollTips: false, // 删除图片合集提示框
            imgListData: [], // 右侧图片列表
            isAllChecked: false, // 是否全选
            selectRecords: 0, // 选择条数
            classifyTips: false, // 分类弹窗
            checkList: [], // 分类选项列表
            editTips: false, // 编辑弹窗
            classImgId: '', // 分类图片ID
            groupId: '', // 分类ID
            currentPageGroupId:'',//当前页面上显示数据的分组id
            renameIndex: '' // 当前重命名的索引
        }
    },
    mounted() {
        if (_.endsWith(this.$route.path, 'video')) {
            this.activeIndex = '1'
        } else {
            this.activeIndex = '2'
        }
        // this.getColListData()
        this.getAllImage()
        this.findAllCapacity()
    },
    methods: {
        toVideo() {
            this.$router.push({name: 'Video'})
        },
        toImage() {
            this.$router.push({name: 'Image'})
        },
        findAllCapacity() {
            this.setLoading(true)
            getAllCapacity({
                success: data => {
                    this.setLoading(false)
                    this.progressBarWidth = `width: ${data.data.percent};`
                    this.totalcapacity = data.data.totalcapacitytext
                    this.usesizetext = data.data.usesizetext
                    if (parseFloat(data.data.usesize) < parseFloat(data.data.totalcapacity)) {
                        this.checkDisabled = false
                    } else {
                        this.checkDisabled = true
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 图片预览
        imgPreview(value) {
            this.$message.success(`预览图片ID--------${value}`)
        },
        // 多选分类
        multipleClassify(value) {
            if (this.selectRecords === 0) {
                this.$message.warning(`请选择要分类的图片`)
                return
            }
            var classifyImgsId = []
            for (let i = 0; i < value.length; i++) {
                if (value[i].aboolean) {
                    classifyImgsId.push(value[i].innerid)
                }
            }
            this.classImgId = classifyImgsId.join(',')
            this.checkList = []
            this.classifyTips = true
        },
        // 多选下载
        multipleDownload(value) {
            if (this.selectRecords === 0) {
                this.$message.warning(`请选择要下载的图片`)
                return
            }
            var downloadImgs = []
            var downloadImgName = []
            for (let i = 0; i < value.length; i++) {
                if (value[i].aboolean) {
                    downloadImgs.push(value[i].csfileurl)
                    downloadImgName.push(value[i].name)
                }
            }
            this.setLoading(true)
            var zip = new JSZip()
            var imgs = zip.folder('images')
            var baseList = []
            var _this = this
            var arr = downloadImgs
            for (let i = 0; i < arr.length; i++) {
                let image = new Image()
                // 解决跨域 Canvas 污染问题
                image.setAttribute('crossOrigin', 'anonymous')
                image.onload = function () {
                    let canvas = document.createElement('canvas')
                    canvas.width = image.width
                    canvas.height = image.height
                    let context = canvas.getContext('2d')
                    context.drawImage(image, 0, 0, image.width, image.height)
                    let url = canvas.toDataURL() // 得到图片的base64编码数据 let url =
                    canvas.toDataURL('image/png')
                    baseList.push(url.substring(22))
                    if (baseList.length === arr.length) {
                        if (baseList.length > 0) {
                            _this.$message.success(`即将下载`)
                            _this.setLoading(false)
                            for (let k = 0; k < baseList.length; k++) {
                                imgs.file('photo' + k + '.png', baseList[k], {base64: true})
                                // imgs.file(downloadImgName[k] + '.png', baseList[k], {base64: true})
                            }
                            zip.generateAsync({type: 'blob'}).then(function (content) {
                                // see FileSaver.js
                                FileSaver.saveAs(content, 'images' + '.zip')
                            })
                        } else {
                            _this.$message.warning(`暂无图片可下载`)
                            _this.setLoading(false)
                        }
                    }
                }
                image.src = arr[i]
            }
        },
        // 多选删除
        multipleDel(value) {
            if (this.selectRecords === 0) {
                this.$message.warning(`请选择要删除的图片`)
                return
            }
            var delImgsId = []
            for (let i = 0; i < value.length; i++) {
                if (value[i].aboolean) {
                    delImgsId.push(value[i].innerid)
                }
            }
            delImgsId = delImgsId.join(',')
            var params = {
                materialinerid: delImgsId,
                materialtype: 2
            }
            this.setLoading(true)
            wholedelete({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log('多选删除图片data:', data)
                    this.selectRecords = 0
                    this.isAllChecked = false
                    this.getAllImage()
                    this.findAllCapacity()
                    this.$message.success(`删除成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分页
        handleSizeChange(val) {
            this.pageParams.page = val
            var params = {
                catalogInnerId: this.groupId
            }
            this.setLoading(true)
            findAllImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    if (data.pageableData !== undefined) {
                        this.total = data.data.pageinfo.rowCount
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
            // if (this.leftMenuIsSelect === -1) {
            //     this.getAllImage()
            // }
        },
        // 上传图片
        setFile(file) {
            var params = {
                vsource: 1,
                keyid: '',
                imageinfo: formatFileInfo(file)
            }
            this.setLoading(true)
            uploadImage({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log('上传图片data:', data)
                    if (data.code === '000') {
                        this.getAllImage()
                        this.findAllCapacity()
                        this.$message.success(`上传图片成功`)
                    }
                    this.$refs.uploadFile.initUploadParam()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 新增图片合集
        sureAddClick() {
            if (this.params.name === '') {
                this.$message.error(`新图片合集名称不能为空`)
                return
            }
            this.setLoading(true)
            addCollection({
                data: Object.assign({}, this.params),
                success: data => {
                    this.setLoading(false)
                    console.log('新增合集:', data)
                    // this.getColListData()
                    this.addImgCollection = false
                    this.leftMenuIsSelect = 0
                    this.groupId = ''
                    this.currentPageGroupId = ''
                    this.getAllImage()
                    this.$message.success(`新增图片合集成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 分类弹窗
        classifyClick(value) {
            this.classifyTips = true
            this.classImgId = value
            this.checkList = []
            // console.log('分类弹窗:', value)
        },
        // 确定分类
        sureClassify() {
            // this.classifyTips = false
            // this.$message.success(`分类成功!`)
            // console.log(this.checkList.join(','))
            // console.log(this.classImgId)
            this.setLoading(true)
            var params = {
                catalogInnerId: this.checkList.join(','), // 图片分类的innerid
                materiaIds: this.classImgId // 单个加入分类图片的innerid
            }
            imgClassify({
                url: `/api/admin/material/catalog/catalogInnerId/image`,
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    // console.log('图片分类data:', data)
                    if (data.code === '000') {
                        // this.getAllImage()
                        this.getGroupImgs(this.groupId)
                        this.$message.success(`图片分类成功`)
                        this.classifyTips = false
                        this.isAllChecked = false
                    }
                    // this.$refs.uploadFile.initUploadParam()
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 下载弹窗
        downloadIamge(imgsrc, name) { // 下载图片地址和图片名
            let image = new Image()
            // 解决跨域 Canvas 污染问题
            image.setAttribute('crossOrigin', 'anonymous')
            image.onload = function() {
                let canvas = document.createElement('canvas')
                canvas.width = image.width
                canvas.height = image.height
                let context = canvas.getContext('2d')
                context.drawImage(image, 0, 0, image.width, image.height)
                let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
                let a = document.createElement('a') // 生成一个a元素
                let event = new MouseEvent('click') // 创建一个单击事件
                a.download = name || 'photo' // 设置图片名称
                a.href = url // 将生成的URL设置为a.href属性
                a.dispatchEvent(event) // 触发a的单击事件
            }
            image.src = imgsrc
        },
        // 编辑弹窗
        editClick(id, name) {
            this.imgNewName = name
            this.imgId = id
            this.editTips = true
        },
        // 确定编辑单个图片名
        sureEdit() {
            if (this.imgNewName === '') {
                this.$message.error(`图片名不能为空！`)
                return
            }
            this.setLoading(true)
            var params = {
                hostinfoinnerid: this.hostinnerid,
                materialinerid: this.imgId,
                name: this.imgNewName
            }
            updateImageofName({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    if (data.code === '000') {
                        // console.log('修改图片data:', data)
                        this.getAllImage()
                        this.$message.success(`修改成功!`)
                    }
                    this.editTips = false
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 删除单个图片弹窗
        allDelete(id) {
            this.$confirm('确认删除该图片么？', '删除图片', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    materialinerid: id,
                    materialtype: 2
                }
                this.setLoading(true)
                wholedelete({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log('删除图片data:', data)
                        this.getAllImage()
                        this.findAllCapacity()
                        this.$message.success(`删除成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 移除分组图片素材
        delClick(id) {
            this.$confirm('确认移除该图片么？', '移除分组', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    materialinerid: id,
                    materialtype: 2,
                    catalogInnerId: this.groupId
                }
                this.setLoading(true)
                delMaterial({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        console.log('移除图片data:', data)
                        this.getGroupImgs(this.groupId)
                        this.$message.success(`移除图片成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 点击选中左侧菜单 添加背景色
        leftMenuClick(value, id) {
            this.leftMenuIsSelect = value
            this.isAllChecked = false
            this.groupId = id
            this.pageParams.page = 1
            if (value === -2) {
                this.groupId = ''
                this.params.name = '' // 重置新增合集名称
                this.addImgCollection = true
                return
            } else {
                this.currentPageGroupId=id
            }
            this.getGroupImgs(this.groupId)
        },
        getGroupImgs(value) {
            this.setLoading(true)
            var params = {
                catalogInnerId: value
            }
            findGroupImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    if (this.pageParams.page === 1) {
                        this.total = data.data.pageinfo.rowCount
                    }
                    // if (data.pageableData !== undefined) {
                    //     this.total = data.pageableData.rowCount
                    // }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 全选
        checkAll() {
            if (this.isAllChecked) {
                this.selectRecords = this.imgListData.length
                for (let i = 0; i < this.imgListData.length; i++) {
                    this.imgListData[i].aboolean = true
                }
            } else {
                this.selectRecords = 0
                for (let i = 0; i < this.imgListData.length; i++) {
                    this.imgListData[i].aboolean = false
                }
            }
        },
        // 右侧图片列表单选
        selectImg(value) {
            // console.log(value)
            this.imgListData[value].aboolean = !this.imgListData[value].aboolean
            // console.log('this.imgListData[value].aboolean:', this.imgListData[value].aboolean)
            var isCheckAll = false
            for (let i = 0; i < this.imgListData.length; i++) {
                if (this.imgListData[i].aboolean === true) {
                    isCheckAll = true
                } else {
                    isCheckAll = false
                    break
                }
            }
            if (this.imgListData[value].aboolean === false) {
                this.isAllChecked = false
                this.selectRecords = this.selectRecords - 1
            } else {
                this.selectRecords = this.selectRecords + 1
                if (isCheckAll) {
                    this.isAllChecked = true
                } else {
                    this.isAllChecked = false
                }
            }
        },
        // 左侧图片合集菜单重命名
        rename(value, id, name) {
            this.renameIndex = value
            this.catalogInnerId = id
            this.newName = name
            this.reNameCollTips = true
        },
        // 确认重命名
        sureRename() {
            if (this.newName === '') {
                this.$message.error(`新的合集名不能为空！`)
                return
            }
            var params = {
                hostinfoinnerid: this.hostinnerid, // 主办方的innerid
                catalogInnerId: this.catalogInnerId, // 素材分类的innerid
                name: this.newName // 重命名名称
            }
            this.setLoading(true)
            imgColReName({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    console.log('合集重命名data:', data)
                    // this.getColListData()
                    // this.getAllImage()
                    this.imgCollection[this.renameIndex].catename = this.newName
                    this.reNameCollTips = false
                    this.$message.success(`修改成功`)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 删除左侧图片合集
        delImgCollection(i, value) {
            // this.leftMenuIsSelect = i
            this.$confirm('确认删除该合辑么？', '删除合集', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                var params = {
                    catalogInnerId: value,
                    materialtype: 2
                }
                this.setLoading(true)
                delMaterialGroup({
                    data: Object.assign({}, params),
                    success: data => {
                        this.setLoading(false)
                        this.leftMenuIsSelect = 0
                        this.groupId = ''
                        this.currentPageGroupId = ''
                        // console.log('删除合集data:', data)
                        // this.getColListData()
                        this.getAllImage()
                        this.$message.success(`删除成功`)
                    },
                    error: data => {
                        console.log('error：', data)
                        this.setLoading(false)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        // 获取合集列表data
        getColListData() {
            this.setLoading(true)
            var params = {
                materialtype: 2
            }
            getColList({
                data: Object.assign({}, params),
                success: data => {
                    // console.log('图片合集列表data:', data)
                    this.imgCollection = data.data
                    this.setLoading(false)
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 获取所有的图片信息
        getAllImage() {
            this.setLoading(true)
            var params = {
                catalogInnerId: ''
            }
            findAllImage({
                data: Object.assign({}, params, this.pageParams),
                success: data => {
                    this.setLoading(false)
                    this.imgListData = data.data.content
                    if (this.pageParams.page === 1) {
                        this.imgCollection = data.data.cataloglist
                    }
                    this.total = data.data.pageinfo.rowCount
                    // if (data.pageableData !== undefined) {
                    //     this.total = data.pageableData.rowCount
                    // }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters([
            'page',
            'user',
            'permission'
        ])
    },
    components: {
        UploadFile
    }
}
</script>

<style lang="scss" scoped type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/mixin";
    .menu_box{
        border-bottom: 1px solid #DCDFE6;
        height: 48px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding: 0 40px 0 20px;
        .nav_box{
            // overflow: hidden;
            .el-menu.el-menu--horizontal {
                border-bottom: 1px solid #DCDFE6;
            }
            .el-menu--horizontal .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
                outline: 0;
                color: #409EFF;
            }
            .el-menu--horizontal>.el-menu-item {
                float: left;
                height: 47px;
                line-height: 47px;
                margin: 0;
                color: #303133;
                font-size:14px;
                font-family:PingFangSC-Regular;
            }
        }
        .volume_box{
            margin-top: 12px;
            background:rgba(245,247,250,1);
            border-radius: 100px;
            overflow: hidden;
            height: 24px;
            width: 140px;
            display: flex;
            align-items: center;
            position: relative;
            div:nth-of-type(1){
                width:0px;
                height:24px;
                background:rgba(64,158,255,1);
            }
            div:nth-of-type(2){
                position: absolute;
                top: 0;
                right: 0;
                width: 140px!important;
                text-align: center;
                height:24px;
                line-height:24px;
                width: 116px;
                border-radius:0 13px 13px 0;
                font-size:12px;
                font-family:PingFangSC-Regular;
                color:rgba(48,49,51,1);
            }
        }
    }
    .image {
        padding-top: 30px;
        display: flex;
        .left_menu_box{
            width: 240px;
            min-height: 500px;
            margin-right: 40px;
            border-right: 1px solid #DCDFE6;
            box-sizing: border-box;
            &>div{
                text-align: right;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                width: 240px;
                font-size:14px;
                font-family:PingFangSC-Regular;
                font-weight:400;
                padding-right: 40px;
                color:rgba(48,49,51,1);
                box-sizing: border-box;
            }
            &>div:hover{
                background:rgba(230,241,252,1);
            }
            .is_select{
                background:rgba(230,241,252,1);
                border-right: 4px solid #409EFF;
                color:rgba(64,158,255,1);
                .el-dropdown-link{
                    color:rgba(64,158,255,1);
                }
            }
            .top_box{
                // background:rgba(230,241,252,1);
                text-align: right;
                padding-right: 36px;
                cursor: pointer;
            }
            .img_list{
                padding-right: 15px;
                .el-dropdown-link {
                    cursor: pointer;
                }
                .el-icon--right {
                    margin-left: 10px;
                }
                .el-dialog__header{
                    display: flex;
                    justify-content: space-between;
                }
                .el-dropdown {
                    span{
                        display: inline-block;
                        width: 180px;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                    }
                }
            }
            .add_box{
                img{
                    width: 12px;
                    height: 12px;
                    &:hover{
                        cursor: pointer;
                    }
                }
                span{
                    padding-left: 20px;
                    &:hover{
                        cursor: pointer;
                    }
                }
            }
        }
        .right_main_box{
            // background-color: rgb(226, 245, 208);
            width: 100%;
            min-width: 500px;
            min-height: 500px;
            padding-right: 40px;
            .top{
                height: 80px;
                border-bottom: 1px solid #DCDFE6;
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
                .left_box{
                    display: flex;
                    .upload_box{
                        margin-right: 15px;
                    }
                    .tips_box{
                        width: 570px;
                        font-size:13px;
                        line-height:20px;
                        color:#909399;
                    }
                }
            }
            .img_content_list{
                .no_content{
                    background-image: url('../../../common/images/other/zwsj@2x.png');
                    background-size:372px 269px !important;
                    background-position:top center !important;
                    background-repeat: no-repeat;
                    height: 500px;
                    // margin-top: 30px;
                    color:rgba(144,147,153,1);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .img_content_box{
                    .select_box{
                        // background-color: rgb(185, 156, 156);
                        color: #606266;
                        display: flex;
                        &>div:nth-of-type(1){
                            .el-checkbox {
                            margin-right: 12px;
                        }
                            &>span{
                                margin-right: 40px;
                            }
                        }
                        &>div:nth-of-type(2){
                            display: flex;
                            align-items: center;
                            &>span{
                                color: #409EFF;
                                margin-right: 12px;
                            }
                            &>span:hover{
                                color: rgb(12, 130, 248);
                                cursor: pointer;
                            }
                        }
                    }
                    .imgs_box{
                        margin-top: 20px;
                        // min-height: 560px;
                        display: flex;
                        flex-wrap: wrap;
                        .img_item{
                            width: 160px;
                            margin-right: 50px;
                            height: 216px;
                            margin-bottom: 50px;
                            &>div:nth-of-type(1){
                                width: 160px;
                                height: 160px;
                                position: relative;
                                img:nth-of-type(1){
                                    width: 160px;
                                    height: 160px;
                                }
                                p{
                                    width: 24px;
                                    height: 24px;
                                    position: absolute;
                                    top: 10px;
                                    left: 10px;
                                    display: none;
                                    cursor: pointer;
                                    background-image: url('../../../common/images/other/Shape@2x.png');
                                    background-size:24px 24px !important;
                                }
                                .show{
                                    display: block!important;
                                    background-image: url('../../../common/images/other/Shape2@2x.png');
                                }
                            }
                            &>div:nth-of-type(1):hover{
                                p{
                                    display: block;
                                }
                            }
                            &>div:nth-of-type(2){
                                color: #606266;
                                margin: 8px 0;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-align: center;
                                line-height: 20px;
                            }
                            &>div:nth-of-type(3){
                                line-height: 20px;
                                &>span{
                                    color: #409EFF;
                                    margin-right: 10px;
                                }
                                &>span:hover{
                                    color: rgb(12, 130, 248);
                                    cursor: pointer;
                                }
                            }
                        }
                        .classify_box{
                            min-height: 60px;
                            max-height: 200px;
                            overflow-y:auto;
                            .el-checkbox {
                                margin-bottom: 10px;
                                width: 160px;
                                overflow: hidden;
                                text-overflow:ellipsis;
                                white-space: nowrap;
                            }
                            .el-checkbox:nth-of-type(3n) {
                                margin-right: 0px;
                            }
                            // .el-checkbox-group{
                            //     display: flex;
                            //     justify-content: space-between;
                            //     flex-wrap: wrap;
                            // }
                        }
                    }
                    .page {
                        @include flexBox(center)
                    }
                }
            }
        }
    }
    .el-dropdown-menu{
        .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover {
            background-color: #ffffff;
        }
        .el-dropdown-menu__item {
            justify-content: center;
        }
        .el-dropdown-menu__item:nth-of-type(2) {
            border-top: 1px solid #ccc;
        }
    }
</style>
<style>
    .el-dialog__wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: left;
    }
    .el-dialog {
        margin: 0!important;
    }
</style>
